(() => {
  class PetomgHeightPicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.productRoot = this.closest('.js-product');
      this.form = this.productRoot?.querySelector('.js-product-form-main');
      this.idInput = this.form?.querySelector('input[name="id"]');
      this.status = this.querySelector('[data-height-status]');
      this.variantData = JSON.parse(this.querySelector('[data-height-variants]').textContent);
      this.product = { id: this.dataset.productId };
      this.unit = 'in';
      this.selected = null;
      this.buttons = Array.from(this.querySelectorAll('[data-variant-id]'));
      this.unitButtons = Array.from(this.querySelectorAll('[data-unit]'));
      this.paymentButton = this.form?.querySelector('.shopify-payment-button');
      this.addButton = this.form?.querySelector('[name="add"]');
      this.addButtonText = this.addButton?.textContent.trim();

      if (!this.form || !this.idInput) return;
      this.idInput.disabled = true;
      if (this.paymentButton) this.paymentButton.hidden = true;
      this.setPurchaseState(false);
      const lowestPrice = this.variantData.reduce((lowest, variant) => variant.price < lowest.price ? variant : lowest);
      this.productRoot.querySelectorAll('.price__current').forEach((node) => { node.textContent = `From ${lowestPrice.priceText}`; });
      this.renderLabels();

      const requestedVariant = new URLSearchParams(window.location.search).get('variant');
      const requestedButton = this.buttons.find((button) => button.dataset.variantId === requestedVariant && !button.disabled);
      if (requestedButton) this.onVariantClick({ currentTarget: requestedButton });

      this.onUnitClick = this.onUnitClick.bind(this);
      this.onVariantClick = this.onVariantClick.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.unitButtons.forEach((button) => button.addEventListener('click', this.onUnitClick));
      this.buttons.forEach((button) => button.addEventListener('click', this.onVariantClick));
      this.form.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      this.unitButtons?.forEach((button) => button.removeEventListener('click', this.onUnitClick));
      this.buttons?.forEach((button) => button.removeEventListener('click', this.onVariantClick));
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.dataset.initialized = 'false';
    }

    onUnitClick(event) {
      this.unit = event.currentTarget.dataset.unit;
      this.unitButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.unit === this.unit)));
      this.renderLabels();
    }

    onVariantClick(event) {
      const variant = this.variantData.find((item) => String(item.id) === event.currentTarget.dataset.variantId);
      if (!variant || !variant.available) return;
      this.selected = variant;
      this.idInput.value = variant.id;
      this.idInput.disabled = false;
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variant.id))));
      if (this.paymentButton) this.paymentButton.hidden = false;
      this.setPurchaseState(true);
      this.status.textContent = `Selected: ${this.formatOption(variant.option)}`;
      this.updateProductState(variant);
    }

    onSubmit(event) {
      if (this.selected) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.status.textContent = 'Please select your measured ceiling height.';
      this.buttons.find((button) => !button.disabled)?.focus();
    }

    updateProductState(variant) {
      this.productRoot.querySelectorAll('.price__current').forEach((node) => { node.textContent = variant.priceText; });
      this.productRoot.querySelectorAll('.product-sku__value').forEach((node) => { node.textContent = variant.sku || ''; });
      this.productRoot.dispatchEvent(new CustomEvent('on:variant:change', {
        bubbles: true,
        detail: { form: this.form, variant, product: this.product }
      }));
    }

    setPurchaseState(isReady) {
      if (!this.addButton) return;
      this.addButton.textContent = isReady ? this.addButtonText : 'Choose height';
    }

    renderLabels() {
      this.buttons.forEach((button) => {
        const variant = this.variantData.find((item) => String(item.id) === button.dataset.variantId);
        button.textContent = this.formatOption(variant.option);
      });
    }

    formatOption(value) {
      const match = value.match(/([\d.]+)cm-([\d.]+)cm\s*\(([\d.]+)\s*in-([\d.]+)\s*in\)/i);
      if (!match) return value;
      return this.unit === 'cm' ? `${match[1]}–${match[2]} cm` : `${match[3]}–${match[4]} in`;
    }
  }

  if (!customElements.get('petomg-height-picker')) customElements.define('petomg-height-picker', PetomgHeightPicker);
})();
